interface milesDisplayProps {
  miles: number
  decimals?: number
}

export const milesDisplay = (props: milesDisplayProps) => {
  const value =
    props.decimals != null ? props.miles.toFixed(props.decimals) : props.miles
  return `${value} ${props.miles === 1 ? 'mile' : 'miles'}`
}

export default milesDisplay
